module.exports = __webpack_public_path__ + "img/SketchPng0f373d8b4229421ce66abca54a611ce05c3a2c99564ca9ef7b02f7a5c02fa116.0817b50f.png";